import React from 'react';
import { Navigate } from 'react-router-dom';

import { isPublicHost, ROUTES } from '../config';

/**
 * Route guard — marketing pages are only served on the apex domain.
 * Tenant subdomains redirect anonymous visitors to the login page.
 */
export default function PublicHostOnly({ children }) {
  if (!isPublicHost()) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }
  return children;
}
